var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v("Check Components Emails")]),
      _vm._v(" "),
      _c("CompassButton", {
        attrs: { label: "Test Button" },
        on: { click: _vm.createEmailPanel }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }